/**
 * Centralized Form Section Component
 * Provides consistent form section layout and styling
 */

import React from 'react';
import {AppTitle} from '../ui/Typography';

export interface FormSectionProps {
  title?: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
  collapsible?: boolean;
  defaultCollapsed?: boolean;
}

const FormSection: React.FC<FormSectionProps> = ({
  title,
  description,
  children,
  className = '',
  collapsible = false,
  defaultCollapsed = false
}) => {
  const [isCollapsed, setIsCollapsed] = React.useState(defaultCollapsed);

  const handleToggle = () => {
    if (collapsible) {
      setIsCollapsed(!isCollapsed);
    }
  };

  return (
    <div className={`bg-white rounded-lg border border-gray-200 p-6 ${className}`}>
      {(title || description) && (
        <div
          className={`mb-6 ${collapsible ? 'cursor-pointer' : ''}`}
          onClick={handleToggle}
        >
          {title && (
            <AppTitle className="text-lg font-semibold text-gray-900 mb-2">
              {title}
              {collapsible && (
                <span className="ml-2 text-gray-500">
                  {isCollapsed ? '▼' : '▲'}
                </span>
              )}
            </AppTitle>
          )}
          {description && (
            <p className="text-sm text-gray-600">{description}</p>
          )}
        </div>
      )}

      {(!collapsible || !isCollapsed) && (
        <div className="space-y-4">
          {children}
        </div>
      )}
    </div>
  );
};

export default FormSection;
